export interface TickerItem {
  id: number;
  label: string;
  text: string;
}

export const tickerItems: TickerItem[] = [
  { id: 1, label: '新料', text: '口碑悬疑剧大结局实时讨论刷新峰值，社区开启全员复盘' },
  { id: 2, label: '热', text: '暑期档黑马大片定档，实时想看数与预售同步走高' },
  { id: 3, label: '曝', text: '户外真人秀录制路透流出，阵容疑似曝光引二轮热议' },
  { id: 4, label: '瓜', text: '「瓜田里的猹」看瓜文学二创合集冲上热搜' },
  { id: 5, label: '新', text: '唱作类音乐综艺新一季剪影官宣，身份推理火热' },
  { id: 6, label: '爆', text: '音乐节名单短暂流出又被删，全网接力整理线索' },
  { id: 7, label: '热', text: '多城文旅消费季市集玩法出圈，打卡热引客流升温' },
];

export interface TimelineStep {
  phase: string;
  time: string;
  title: string;
  text: string;
}

export const timelineSteps: TimelineStep[] = [
  {
    phase: '起点',
    time: '第 1 天',
    title: '信号初现：一条小范围信息被转发',
    text: '某个话题最初只是出现在小范围截图与评论中，被少数网友发现后转发，尚未形成规模讨论，但内容本身带有较强的讨论张力。',
  },
  {
    phase: '发酵',
    time: '第 2 天',
    title: '多平台接力：博主与社区开始整理时间线',
    text: '随着截图被搬运到多个平台，不同博主与社区开始补充背景、梳理时间线，关键词搜索量明显爬升，话题逐渐进入更多人的视野。',
  },
  {
    phase: '升温',
    time: '第 2-3 天',
    title: '多方回应：讨论走向"反转与补充"循环',
    text: '当热度达到一定阈值，相关方开始陆续发声。每一次补充都会带来新的讨论分支，"反转—再补充—再解读"的节奏让事件热度持续走高。',
  },
  {
    phase: '引爆',
    time: '第 3 天',
    title: '登顶热榜：核心节点被集中消费',
    text: '在多个信息的相互印证下，事件进入最集中的讨论期，相关话题多次登上全网热榜，围观人群达到峰值，二创与解读内容集中产出。',
  },
  {
    phase: '沉淀',
    time: '第 4-5 天',
    title: '热度回落：结论与复盘开始沉淀',
    text: '随着关键信息基本明朗，即时讨论逐渐降温，转向观点复盘与经验总结，事件留下的讨论框架也会在后续同类热点中被反复引用。',
  },
];